module.exports = __webpack_public_path__ + "4a90dffaf77c2b0b154478b5da0abe39.MP3";